/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <div class="store_login_unit_manage_menu">店舗管理者画面</div>
            <div class="store_tbl_unit wd976 tbl_ht_login_info tbl_bg_blue">
                <form class="form_checkSetting">

                    <div class="wd720">
                        <p v-if="this.viewtype== 'day1'" class="checkSetting_text">TOPボタンA メニュー画面 {{this.buttonname}}  ページNo{{this.page}}</p>
                        <p v-else-if="this.viewtype== 'day2'" class="checkSetting_text">TOPボタンD メニュー画面 {{this.buttonname}}  ページNo{{this.page}}</p>
                    </div><br>
                    <div class="wd720">
                        <Message v-if="apivalidationMessage || !addFormFlg" :validationMessage="alertMessage" /><br>
                        <Message v-if="apivalidationMessage" :validationMessage="apivalidationMessage" />
                    </div>

                    <div class="lavel_store right_comment">
                        <img v-if="dailyCheckPageSettings.displayFlg == 1"  class="required" src="../assets/required.png" /><br />
                        <label>チェック項目設定</label>
                    </div>
                    <div  style="padding: 15px" id="checkSetting" name="pageSetting" >
                        <table class="checkSetting_tbl_unit">
                            <tbody>
                            <tr>
                                <th class="wd100 checkSetting_text_align">表示順</th>
                                <th class="wd400 checkSetting_text_align">チェック内容</th>
                                <th class="wd100 checkSetting_text_align" >チェック実施有無</th>
                            </tr>
                            <tr v-for="dailyCheckItemList in dailyCheckItemLists" :key=dailyCheckItemList.dailyCheckItemNo>
                                <td class="wd100 checkSetting_text_align">{{dailyCheckItemList.dailyCheckItemNo}}</td>
                                <td class="wd400 view_setting_text_td">{{dailyCheckItemList.dailyCheckItemName}}</td>
                              <td class="wd100 checkSetting_text_align">
                                <input v-if="dailyCheckItemList.dailyCheckItemId !== null" type="checkbox" name="checkbox02" :id="dailyCheckItemList.dailyCheckItemNo" v-model="selectedDailyCheckItemNo" :value="dailyCheckItemList.dailyCheckItemNo">
                                <label v-if="dailyCheckItemList.dailyCheckItemId !== null" class="checkbox02" :for="dailyCheckItemList.dailyCheckItemNo"></label>
                              </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                </form><br>
            </div>
            <div>
                <div class="btn_submit" style="text-align: center">
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li><a class="checkSetting_buttan_unit " href="#" @click.prevent.stop="cancel">キャンセル</a></li>
                    </ul>
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li><a class="checkSetting_buttan_unit " href="#" @click.prevent.stop="openModel">更新</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd570">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">チェック実施編集 更新確認</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p >更新しました。</p>
                    </div>

                    <div class="btn_submit_box">
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="closeModel">OK</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>

</template>

<script>
import PulseLoader from '@/app/components/PulseLoader.vue'
import Message from '@/app/components/Message.vue'
export default {
    name: 'CheckImplementationViewSettingPage',
    components: {
        PulseLoader,
        Message
    },
    data: function () {
        return {
            showContent:false,
            applyStartDate:null,
            isLoading:false,
            isInitLoading:true,
            apivalidationMessage:'',
            alertMessage:'入力エラーがあります。',
            brandId: '',
            storeId: '',
            selectedDailyCheckItemNo: [],
            dailyCheckItemLists:[
                {   dailyCheckItemId:null,
                    dailyCheckItemNo:null,
                    dailyCheckItemName:'',
                    implementationFlg:''
                }
            ],
            dailyCheckPageSettings: {
                dailyCheckItemSettings: [],
                arrangementRuleSettings: [],
                displayFlg: null,
            },
            addFormFlg: true,
        }
    },
    computed: {
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
        id: function () {
            return this.$store.getters['checkPage/dailyCheckPageId']
        },
        viewtype: function () {
            return this.$store.getters['checkPage/viewType']
        },
        bottunid: function () {
            return this.$store.getters['checkPage/buttonId']
        },
        buttonname: function () {
            return this.$store.getters['checkPage/buttonName']
        },
        page: function () {
            return this.$store.getters['checkPage/dailyCheckPageNo']
        },
    },
    created: function(){
        this.calc();
    },
    methods:{
        async calc(){

            var apiResponseFlg = true;
            this.isInitLoading = true;

            // 企業IDを取得
            this.brandId = this.$store.getters['brand/id'];
            // 店舗IDの取得
            this.storeId = this.$store.getters['store/id'];
            var applyStartDate = "";

            // パラメータ初期化
            this.clearError();
            this.addFormFlg = true;

            // 取得する日付を指定
            if(this.applyStartDate !== null){
                applyStartDate = this.applyStartDate;
            }

            // メニューページ情報取得API
            await this.$axios
                .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/' + this.storeId + '/menu/page/' + this.id, { params: { apply_start_date:applyStartDate}})
                .then(response => (this.dailyCheckPageSettings = response.data,
                        this.applyStartDate = response.data.applyStartDate
                ))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    apiResponseFlg = false;
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isInitLoading = false);
            if(apiResponseFlg){
                this.dailyItemData();
            }
        },
        async openModel() {

            this.isLoading = true;
            var apiResponseFlg = true;
            this.apivalidationMessage = '';

          // 必須チェック
          this.validRequired();
          if(!this.addFormFlg){
            this.isLoading = false;
            this.scrollTop();
            return null;
          }

            // request作成
            var requestBody = {}
            var daily_check_item_store_settings = [];

            this.dailyCheckItemLists.forEach(dailyCheckItemSetting => {
              var implementationFlg = 0;
              if(dailyCheckItemSetting.dailyCheckItemId !== null) {
                if(this.selectedDailyCheckItemNo.includes(dailyCheckItemSetting.dailyCheckItemNo)) {
                  implementationFlg = 1;
                }
                var daily_check_item_store_setting = {
                  daily_check_item_no: dailyCheckItemSetting.dailyCheckItemNo,
                  implementation_flg: implementationFlg,
                }

                daily_check_item_store_settings.push(daily_check_item_store_setting);
              }
            });
            requestBody.daily_check_item_store_settings = daily_check_item_store_settings;
            var formRequestBody = this.jsonToFormData(requestBody);

            var config = {
                headers: {
                    'Content-Type': 'multipart/form-data;'
                }
            }

            // メニューページ情報更新API
            await this.$axios
                .post(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/' + this.storeId + '/menu/page/' + this.id, formRequestBody, config)
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    apiResponseFlg = false;
                    if (err.customError) {
                        // APIのエラー情報をerrorに入れる
                        error = Object.assign(error, err.customError)
                        // エラーコードが400であればバリデーションエラーなので画面に表示する
                        if (error.code == 400) {
                            this.apivalidationMessage = error.message
                            this.scrollTop();
                        }
                    }
                    if (this.apivalidationMessage == '') {
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                }).finally(()=> this.isLoading = false);

            if(apiResponseFlg){
                this.showContent = true;
            }
        },
        dailyItemData:function(){

            // デイリーデータの表示データを成形
            this.selectedDailyCheckItemNo = [];
            let itemList = [];
            for(var k = 0 ; k < 50 ; k++){
                var indexList = new Object();
                var settingFlg = false
                this.dailyCheckItemLists = [];

                for( var i=0 ; i < this.dailyCheckPageSettings.dailyCheckItemSettings.length ; i++){
                    if(this.dailyCheckPageSettings.dailyCheckItemSettings[i].dailyCheckItemNo == (k + 1)){
                        indexList['dailyCheckItemId']  = this.dailyCheckPageSettings.dailyCheckItemSettings[i].dailyCheckItemId;
                        indexList['dailyCheckItemNo']  = this.dailyCheckPageSettings.dailyCheckItemSettings[i].dailyCheckItemNo;
                        indexList['dailyCheckItemName']  = this.dailyCheckPageSettings.dailyCheckItemSettings[i].dailyCheckItemName;
                        indexList['implementationFlg']  = this.dailyCheckPageSettings.dailyCheckItemSettings[i].implementationFlg;
                      if(this.dailyCheckPageSettings.dailyCheckItemSettings[i].implementationFlg == 1) {
                          this.selectedDailyCheckItemNo.push(this.dailyCheckPageSettings.dailyCheckItemSettings[i].dailyCheckItemNo);
                        }
                        settingFlg = true;
                        break;
                    }
                }
                if(settingFlg == false){
                    indexList['dailyCheckItemId']  = null;
                    indexList['dailyCheckItemNo']  = k + 1;
                    indexList['dailyCheckItemName']  = '';
                    indexList['implementationFlg']  = '';
                }
                itemList.push(indexList);
            }
            this.dailyCheckItemLists = itemList;
        },
        cancel(){
            this.$router.push({name: 'manageCheckImplementationViewSetting',params:{ bottunid:this.bottunid }});
        },
        buildFormData(formData, data, parentKey) {
            if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                Object.keys(data).forEach(key => {
                    this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
                });
            } else {
                const value = data == null ? '' : data;

                formData.append(parentKey, value);
            }
        },
        jsonToFormData(data) {
            const formData = new FormData();

            this.buildFormData(formData, data);

            return formData;
        },
        validRequired() {
          this.addFormFlg = true;

          //エラー内容初期化
          this.clearError();
          let dailyCheckItem = this.dailyCheckItemLists.filter(item => item.dailyCheckItemId !== null )
            // 必須チェック
            if(dailyCheckItem.length <= 0){
              this.alertMessage="チェック項目が設定されていません。"
              this.addFormFlg = false;
            }
            // 表示設定
            if(this.dailyCheckPageSettings.displayFlg == null){
                this.alertMessage="表示設定が非表示のため変更できません。"
                this.addFormFlg = false;
            }
        },

        clearError(){
            //メッセージ初期化
            this.alertMessage = "";
        },
        scrollTop() {
            window.scrollTo(0,0);
        },
        closeModel(){
            this.showContent = false;

            // 初期化処理
            this.calc();
        },
    }
}
</script>